import React, { Component } from "react";

import { Access } from "common";
import { Page, Breadcrumbs, Navigation } from "components";

class Main extends Component {
  state = {
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Pontos", to: "" },
    ],
    navigation: [
      { name: "Lista de Vouchers (Pontos)", to: "/points/vouchers" },
      {
        name: "Campanhas de Pontos",
        to: "/points/multiplier",
        hidden: !Access.hasPermissions(["manage-multiplier"]),
      },
      { name: "Canais", to: "/points/channels" },
      { name: "Tipos de Produtos", to: "/points/products-types" },
      { name: "Meios de Pagamento", to: "/points/payments" },
      { name: "Lojas", to: "/points/stores" },
      { name: "Premiação", to: "/points/prizes" },
      {
        name: "Atribuir Pontos para uma Lista de CPFs",
        to: "/points/cpf-list",
        hidden: !Access.hasPermissions(["manage-points-assigner"]),
      },
    ],
  };

  render() {
    const { breadcrumbs, navigation } = this.state;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Navigation items={navigation} />
      </Page>
    );
  }
}

export default Main;
